/**
 * Copyright Fitzba Technologies Inc. 2023
 *
 * Item is a functional React component that renders a single item
 * in the list view, with an image, title, rating, price, and other details.
 *
 * @author Yang Ming
 * @version June 07, 2023
 */
import React from 'react'
import { getShortString, getDistance } from '@utils/Helper'
import { Link, useNavigate } from 'react-router-dom'
import ItemPrice from './ItemPrice'
import { getItemLink, getStoreLink } from '@utils/Helper'
import MyImage from '@components/MyImage'
import { useDispatch, useSelector } from 'react-redux'
import { setFilterStoreOnlyOne } from '@reducers/contentReducer'
import { setFilterBrand } from '@reducers/contentReducer'
import ItemRating from './ItemRating'
import ItemLiveInventoryIcon from './ItemLiveInventoryIcon'
import ItemPickupTags from './ItemPickupTags'
import CanadianBrandIcon from 'pages/itemDetail/components/CanadianBrandIcon'

export default function ServiceCard({
  service,
  handleAddToCart,
  keywordsList,
}) {
  const location = useSelector((state) => state.user.location)
  // console.log('ItemCard',item)
  // highlight keywords in title
  const getTitle = () => {
    let title = getShortString(service?.title, 50)
    if (keywordsList && keywordsList.length > 0) {
      title = title.replace(
        new RegExp(`(${keywordsList.join('|')})`, 'gi'),
        '<font color="#E4B456">$1</font>',
      )
    }
    return title
  }

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const itemLink = getItemLink(service._id, service?.title)
  const storeLink = getStoreLink(service?.business?.shortLink, service?.business?.city, service?.business?.province)
  // console.log('storeLink',storeLink)
  return (
    // <div className='flex w-full justify-center p-0 font-lexend md:w-fit'>
    <div className='flex flex-col gap-3 justify-between w-[350px] relative h-[450px] text-center bg-white rounded-2xl border-2 p-5 hover:border-[#E4B456] shadow-sm shadow-gray-300 transition-all duration-200 ease-in-out'>
      {/* {service?.isRecommended && (
                <FaGripfire className='text-[30px] text-[#E4B456] m-auto absolute top-[10px] left-[10px]' />
            )} */}
      <div className='w-full h-[450px] flex flex-col justify-between items-center gap-5'>
        <div className='flex flex-col items-center justify-center gap-3'>
          <div className='flex flex-col items-center justify-center gap-3'>
            <h3 className="text-xl font-medium text-gray-800 smsize:text-[16px] smsize:leading-5">
              {service?.title.indexOf('<br>') !== -1 ? <p dangerouslySetInnerHTML={{ __html: service.title }}></p> : service.title}
            </h3>
            <div className='flex flex-col items-center justify-center text-[18px] text-[#E4B456] font-medium'>
              {service.time_money_str ?
                <span className='' dangerouslySetInnerHTML={{ __html: service.time_money_str }} ></span> :
                <>
                  {service.duration > 0 && <span className=''>{service.duration} Minutes</span>}
                  {service.price > 0 && <span className=''>${service.price}</span>}
                </>
              }
            </div>

          </div>
          <p className='text-[15px] leading-5 font-light text-left line-clamp-[7] overflow-y-hidden' dangerouslySetInnerHTML={{ __html: service.description }}></p>

        </div>
        <div className='flex flex-col items-center justify-center gap-3'>
          <div className='flex justify-center mt-5'>
            <a
              href={`https://flirtcosmetics.zenoti.com/webstoreNew/services/223d7d44-e6d0-4c03-9841-e653d25d4d0c?serviceid=${service.pos_service_id}`}
              target='_blank'
              rel="noopener noreferrer"
              className="bg-[#202020] rounded-full cursor-pointer hover:bg-fitzba-bright-gold-static text-white py-2 px-4 w-[200px]">
              Book Now
            </a>
          </div>
          <div className='flex items-center gap-2'>
            <img src={service?.business?.logo} className='w-[32px] h-[32px] object-contain rounded-full' alt={service?.business?.name} />
            <h3
              onClick={() => {
                dispatch(setFilterStoreOnlyOne(service?.business?._id))
                navigate(storeLink)
              }}
              title={service?.title}
              className='uppercase truncate text-[12px] text-[#727272]'
            >
              {service?.business?.name}
            </h3>
          </div>
          {service?.distance && (
            <p className='mb-1 truncate text-xs text-black'>
              <span className='text-[10px] font-light'>
                {getDistance(service?.distance, location?.country === 'US')?.toUpperCase()}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
    // </div>
  )
}
